import React, { useEffect, useState } from "react";
import { TextField, Button, FormHelperText, Modal, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  yourProfileDetailsAPICall,
  startOverAPICall,
  stageDetailsAPICall,
  CommonDropDownAPICall,
} from "../shared/APICalls";
import { IYourProfileDetails, IYourProfilePrefillData } from "../shared/dtos";
import routesData from "../shared/routes.json";
import ProfileStyles from "../pages/Styles/YourProfile.module.scss";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/profileicongrey.svg";
import CommonDropdown from "../Components/SelectDropdown/CommonDropDown";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";
import PloiticalModal from "../Components/Modals/PoliticalModal/PoliticalModal";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";
import CommonDropdownLatest from "../Components/SelectDropdown/CommonDropDownLatest";
import CommonRadioGroup from "../Components/SelectDropdown/CommonRadioGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { isMobile } from "react-device-detect";
import SideBar from "../Components/SideBar/SideBar";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import ProgressBar from "../Components/ProgressBar/ProgressBar";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";

const schema = Yup.object().shape({
  fatherFullName: Yup.string()
    .required("Father Name is Required")
    .min(3, "Minimum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .max(50)
    .transform((value: any) => value && value.toUpperCase()),
  motherFullName: Yup.string()
    .required("Mother Name is Required")
    .max(50)
    .min(3, "Minimum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase()),
  annualIncome: Yup.object().required("Please select an option"),
  tradingExperience: Yup.object().required("Please select an option"),
  occupation: Yup.object().required("Please select an option"),
  occupationIfOthers: Yup.string()
    .nullable()
    .when("occupation", (occupation, schema) => {
      if (
        Array.isArray(occupation) &&
        occupation.length > 0 &&
        occupation[0]?.value === "Others"
      ) {
        return schema
          .required("Please Enter Occupation Others")
          .matches(/^[a-zA-Z ]*$/, "Enter a valid occupation")
          .min(3, "Minimum 3 letters are required")
          .max(50, "Maximum 50 characters allowed")
          .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed");
      }
      return schema.notRequired();
    }),

  areYouPoliticallyExposed: Yup.object().required("Please select an option"),
  maritalStatus: Yup.object().required("Marital Status is required"),
});

const successModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  boxShadow: 24,
  outline: "none",
  display: "flex",
};

const maritalStatus = [
  {
    id: "single",
    sequence: 1,
    value: "Single",
  },
  {
    id: "married",
    sequence: 2,
    value: "Married",
  },
];
const politicallyExposed = [
  {
    id: "no",
    sequence: 1,
    value: "No",
  },
  {
    id: "yes",
    sequence: 2,
    value: "Yes",
  },
];

export default function YourProfilePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //Loaders
  const [loading, setloading] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [occupationOther, setOthersDataFeild] = useState<any>();
  const [annualDropDownData, setAnnualDropDownData] = useState<any>([]);
  const [tradingExperienceDropdownData, settradingExperienceDropdownData] =
    useState<any>([]);
  const [occupationDropdownData, setoccupationDropdownData] = useState<any>([]);
  const [displayFatherNameField, setdisplayFatherNameField] =
    useState<any>(true);
  const [prefillData, setprefillData] = useState<IYourProfilePrefillData>({
    fatherFullName: "",
    motherFullName: "",
    annualIncome: "",
    tradingExperience: "",
    occupation: "",
    areYouPoliticallyExposed: "",
    maritalStatus: "",
    occupationIfOthers: "",
  });
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [startOverloading, setstartOverloading] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const [pastActions, setPastActions] = useState("");
  const [otherBrokers, setOtherBrokers] = useState("");
  const [expandOthers, setExpandOthers] = useState(false);
  const [expandMenu, setExpandMenu] = useState<any>(false);
  const navigationData = routesData;

  function setOthersData(data: any) {
    // console.log(data);

    setOthersDataFeild(data);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
    let annualFetchedData;
    let tradingFetchedData;
    let OccupationFetchedData;
    setprefilloading(true);
    let dd_type = "profile";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        const responseData = response.data.data;

        setAnnualDropDownData(
          responseData.annual_income
            .map((a: any) => {
              return a;
            })
            .sort((a: any, b: any) => a.sequence - b.sequence),
        );
        annualFetchedData = responseData.annual_income.map((a: any) => {
          return a;
        });

        settradingExperienceDropdownData(
          responseData.trading_exp
            .map((a: any) => {
              return a;
            })
            .sort((a: any, b: any) => a.sequence - b.sequence),
        );

        tradingFetchedData = responseData.trading_exp.map((a: any) => {
          return a;
        });
        setoccupationDropdownData(
          responseData.occupation.map((a: any) => {
            return a;
          }),
        );

        OccupationFetchedData = responseData.occupation.map((a: any) => {
          return a;
        });

        // API Call
        let obj: any = {
          stage: "customer_details",
        };

        stageDetailsAPICall(obj)
          .then((response: any) => {
            setprefilloading(false);

            const responseData = response.data;

            dispatch(setCompletedStages(responseData.data.completed_stages));
            dispatch(setCurrentStage(responseData.data.current_stage));
            const annualIncomeReturned = annualFetchedData.filter(
              (data: any) =>
                data.value === responseData.data.data.annual_income,
            )[0];
            const tradingExperienceReturned = tradingFetchedData.filter(
              (data: any) => data.value === responseData.data.data.trading_exp,
            )[0];
            const occupationReturned = OccupationFetchedData.filter(
              (data: any) =>
                data.value === responseData.data.data.occupation.occ_value,
            )[0];

            setRejectMessage(responseData.data.ErrorMessage);

            setOthersDataFeild(
              responseData.data.data.occupation.occ_value === "Others"
                ? "Others"
                : responseData.data.data.occupation.others_value,
            );
            setprefillData((prev) => {
              return {
                ...prev,
                fatherFullName: responseData.data.data.father_name,
                motherFullName: responseData.data.data.mother_name,
                annualIncome: annualIncomeReturned ? annualIncomeReturned : "",
                maritalStatus:
                  responseData.data.data.marital_status === "married"
                    ? maritalStatus[1]
                    : responseData.data.data.marital_status === "single"
                      ? maritalStatus[0]
                      : "",
                areYouPoliticallyExposed:
                  responseData.data.data.political_exposed === true
                    ? politicallyExposed[1]
                    : responseData.data.data.political_exposed === false
                      ? politicallyExposed[0]
                      : politicallyExposed[0],
                tradingExperience: tradingExperienceReturned
                  ? tradingExperienceReturned
                  : "",
                occupation: occupationReturned ? occupationReturned : "",
                occupationIfOthers:
                  responseData.data.data.occupation.others_value,

                // settlements: preferenceType ? preferenceType : Settlements[0],
              };
            });
          })
          .catch((error: any) => {
            setprefilloading(false);
            setdisplayFatherNameField(true);
            //  console.log("error", error);
          });
      })
      .catch((error: any) => {
        setprefilloading(false);
        // console.log("error", error);
      });
  }, []);

  const annualIncomeOptions = annualDropDownData;
  const tradingExperienceOptions = tradingExperienceDropdownData;
  const occupationOptions = occupationDropdownData;

  function yourProfile(data: any) {
    if (data.areYouPoliticallyExposed.id === "yes") {
      setopenModal(true);
    } else {
      TagManager.dataLayer({
        dataLayer: {
          event: "formSubmitProfile",
        },
      });
      setloading(true);
      let obj: IYourProfileDetails = {
        marital_status: data.maritalStatus.id,
        father_name: data.fatherFullName.toUpperCase(),
        mother_name: data.motherFullName.toUpperCase(),
        annual_income: data.annualIncome.value,
        trading_exp: data.tradingExperience.value,
        occupation: data.occupation.value,
        occupation_others:
          occupationOther === "Others"
            ? data.occupationIfOthers.toUpperCase()
            : "",
        politically_exposed: data.areYouPoliticallyExposed.id,
      };
      yourProfileDetailsAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          // console.log(responseData);
          setloading(false);
          if (
            responseData.data.next_stage &&
            navigationData.hasOwnProperty(responseData.data.next_stage)
          ) {
            navigate(navigationData[responseData.data.next_stage]);
          }
        })
        .catch((error: any) => {
          setloading(false);
        });
    }
  }

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            setstartOverloading(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setstartOverloading(false);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };
  const initialValues: IYourProfilePrefillData = {
    fatherFullName: prefillData.fatherFullName,
    motherFullName: prefillData.motherFullName,
    annualIncome: prefillData.annualIncome,
    tradingExperience: prefillData.tradingExperience,
    occupation: prefillData.occupation,
    areYouPoliticallyExposed: prefillData.areYouPoliticallyExposed,
    maritalStatus: prefillData.maritalStatus,
    occupationIfOthers:
      prefillData.occupationIfOthers === null
        ? ""
        : prefillData.occupationIfOthers,
    // settlements: prefillData.settlements,
  };

  const handleDone = () => {
    setopenModal(false);
  };

  // console.log("occupationOther", occupationOther);

  return (
    <>
      <ErrorSnackBar message={rejectMessage} />
      {backdrop && <StartOverBackDrop />}
      <div className={ProfileStyles.layout}>
        <div className={ProfileStyles.sidebar}>
          <SideBar />
        </div>
        <div className={ProfileStyles.pageContent}>
          <div className={ProfileStyles.mainWrapper}>
            <>
              <div className={ProfileStyles.wrapper}>
                <div className={ProfileStyles.leftContainer}>
                  {!prefilloading ? (
                    <Formik
                      validationSchema={schema}
                      initialValues={initialValues}
                      onSubmit={(values: any) => {
                        // console.log("values", values);
                        yourProfile(values);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                      }) => {
                        // console.log("values", values);
                        // console.log("errors", errors);
                        return (
                          <form
                            autoComplete="off"
                            noValidate
                            onSubmit={handleSubmit}
                            onKeyDown={(event) => {
                              event.code === "Enter" && handleSubmit();

                              // event.code.includes("Enter") && handleSubmit()
                            }}
                          >
                            <div className={ProfileStyles.contentWrapper}>
                              <div className={ProfileStyles.wrap}>
                                <div className={ProfileStyles.headerSection}>
                                  <p className={ProfileStyles.signup}>
                                    <div className={ProfileStyles.mobileBack}>
                                      {/* <ArrowBackIosIcon /> */}
                                    </div>
                                    Share A Bit About Yourself
                                    <div
                                      className={ProfileStyles.mobileMenu}
                                      onClick={() => {
                                        setExpandMenu(!expandMenu);
                                      }}
                                    >
                                      {expandMenu ? (
                                        <CloseIcon />
                                      ) : (
                                        <MenuIcon />
                                      )}
                                    </div>
                                  </p>
                                  <ProgressBar />
                                  <div
                                    className={ProfileStyles.mobileexpandedMenu}
                                    style={{
                                      height: expandMenu ? "100%" : "0%",
                                    }}
                                  >
                                    <div
                                      className={
                                        ProfileStyles.mobilemenuContent
                                      }
                                    >
                                      <SideBar />
                                    </div>
                                  </div>
                                </div>
                                <div className={ProfileStyles.topContainer}>
                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Father's Name{" "}
                                      <span style={{ color: "#E8556D" }}>
                                        *
                                      </span>
                                    </div>
                                    {displayFatherNameField && (
                                      <TextField
                                        autoComplete="new-password"
                                        className={ProfileStyles.textfield}
                                        id="outlined-basic"
                                        // label="Father's Name"
                                        placeholder="Father's Name"
                                        variant="outlined"
                                        name="fatherFullName"
                                        value={
                                          values.fatherFullName &&
                                          values.fatherFullName.toUpperCase()
                                        }
                                        error={
                                          touched.fatherFullName &&
                                          Boolean(errors.fatherFullName)
                                        }
                                        helperText={
                                          touched.fatherFullName &&
                                          errors.fatherFullName?.toString()
                                        }
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        inputProps={{
                                          sx: {
                                            "&::label": {
                                              fill: "#111827",
                                              fontWeight: 400,
                                              fontSize: "14px",
                                            },
                                            color: "var(--ds-text-primary)",
                                            fontSize: "14px",
                                            "&::placeholder": {
                                              color: "var(--ds-text-secondary)",
                                              fontWeight: 400,
                                              fontSize: "14px",
                                              opacity: 0.6,
                                            },
                                          },
                                          maxLength: 50,
                                          inputMode: "text",
                                          form: {
                                            autoComplete: "off",
                                          },
                                        }}
                                        sx={{
                                          fieldset: {
                                            borderColor: "#E5E7EB",
                                          },
                                        }}
                                        InputLabelProps={{
                                          sx: {
                                            color: "var(--ds-text-secondary)",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            // marginTop:"2px",
                                            "&.MuiFormLabel-filled": {
                                              color: "var(--ds-text-primary)",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              fontFamily: "inherit",
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  </div>

                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Mother's Name{" "}
                                      <span style={{ color: "#E8556D" }}>
                                        *
                                      </span>
                                    </div>
                                    <TextField
                                      autoComplete="new-password"
                                      className={ProfileStyles.textfield}
                                      id="outlined-basic"
                                      // label="Mother's Name"
                                      placeholder="Mother's Name"
                                      variant="outlined"
                                      name="motherFullName"
                                      value={
                                        values.motherFullName &&
                                        values.motherFullName.toUpperCase()
                                      }
                                      error={
                                        touched.motherFullName &&
                                        Boolean(errors.motherFullName)
                                      }
                                      helperText={
                                        touched.motherFullName &&
                                        errors.motherFullName?.toString()
                                      }
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      inputProps={{
                                        sx: {
                                          "&::label": {
                                            fill: "var(--ds-text-primary)",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                          },
                                          color: "var(--ds-text-primary)",
                                          fontSize: "14px",
                                          "&::placeholder": {
                                            color: "var(--ds-text-secondary)",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            opacity: 0.6,
                                          },
                                        },
                                        maxLength: 50,
                                        inputMode: "text",
                                        form: {
                                          autoComplete: "off",
                                        },
                                      }}
                                      sx={{
                                        fieldset: {
                                          borderColor: "#E5E7EB",
                                        },
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          color: "var(--ds-text-secondary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          "&.MuiFormLabel-filled": {
                                            color: "var(--ds-text-primary)",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            fontFamily: "inherit",
                                          },
                                        },
                                      }}
                                    />
                                  </div>

                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Trading Experience{" "}
                                      <span style={{ color: "#E8556D" }}>
                                        *
                                      </span>
                                    </div>
                                    <CommonDropdownLatest
                                      LabelName="Trading Experience"
                                      menuItems={tradingExperienceOptions}
                                      name="tradingExperience"
                                      value={values.tradingExperience}
                                      handleChange={handleChange}
                                      error={
                                        touched.tradingExperience &&
                                        Boolean(errors.tradingExperience)
                                      }
                                      helperText={
                                        touched.tradingExperience &&
                                        errors.tradingExperience
                                      }
                                      setOthers={""}
                                    />
                                  </div>
                                </div>

                                <div className={ProfileStyles.topContainer}>
                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Occupation{" "}
                                      <span style={{ color: "#E8556D" }}>
                                        *
                                      </span>
                                    </div>
                                    <CommonDropdownLatest
                                      LabelName="Occupation"
                                      menuItems={occupationOptions}
                                      name="occupation"
                                      value={values.occupation}
                                      handleChange={handleChange}
                                      error={
                                        touched.occupation &&
                                        Boolean(errors.occupation)
                                      }
                                      helperText={
                                        touched.occupation && errors.occupation
                                      }
                                      setOthers={setOthersData}
                                    />
                                  </div>
                                  {isMobile && (
                                    <>
                                      {occupationOther === "Others" && (
                                        <div
                                          className={
                                            ProfileStyles.textFeildWrapper
                                          }
                                          style={{
                                            width: "100%",
                                          }}
                                        >
                                          <div
                                            className={ProfileStyles.labeltext}
                                          >
                                            Occupation Other's{" "}
                                            <span style={{ color: "#E8556D" }}>
                                              *
                                            </span>
                                          </div>
                                          <TextField
                                            autoComplete="off"
                                            id="outlined-basic"
                                            placeholder="Enter Your Occupation"
                                            variant="outlined"
                                            name="occupationIfOthers"
                                            value={values.occupationIfOthers.toUpperCase()}
                                            error={
                                              touched.occupationIfOthers &&
                                              Boolean(errors.occupationIfOthers)
                                            }
                                            helperText={
                                              touched.occupationIfOthers &&
                                              errors.occupationIfOthers?.toString()
                                            }
                                            className={ProfileStyles.textfield}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            inputProps={{
                                              sx: {
                                                "&::label": {
                                                  fill: "var(--ds-text-primary)",
                                                  fontWeight: 400,
                                                  fontSize: "14px",
                                                },
                                                color: "var(--ds-text-primary)",
                                                fontSize: "14px",
                                                "&::placeholder": {
                                                  color:
                                                    "var(--ds-text-secondary)",
                                                  fontWeight: 400,
                                                  fontSize: "14px",
                                                  opacity: 0.6,
                                                },
                                              },
                                              maxLength: 50,
                                              inputMode: "text",
                                            }}
                                            sx={{
                                              fieldset: {
                                                borderColor: "#E5E7EB",
                                                borderRadius: "100px",
                                              },
                                            }}
                                            InputLabelProps={{
                                              sx: {
                                                color:
                                                  "var(--ds-text-secondary)",
                                                fontWeight: 400,
                                                fontSize: "14px",
                                                "&.MuiFormLabel-filled": {
                                                  color:
                                                    "var(--ds-text-primary)",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  fontFamily: "inherit",
                                                },
                                              },
                                            }}
                                          />
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {!isMobile && (
                                    <>
                                      {occupationOther === "Others" ? (
                                        <div
                                          className={
                                            ProfileStyles.textFeildWrapper
                                          }
                                        >
                                          <div
                                            className={ProfileStyles.labeltext}
                                          >
                                            Occupation Other's{" "}
                                            <span style={{ color: "#E8556D" }}>
                                              *
                                            </span>
                                          </div>
                                          <TextField
                                            autoComplete="off"
                                            id="outlined-basic"
                                            placeholder="Enter Your Occupation"
                                            variant="outlined"
                                            name="occupationIfOthers"
                                            value={values.occupationIfOthers.toUpperCase()}
                                            error={
                                              touched.occupationIfOthers &&
                                              Boolean(errors.occupationIfOthers)
                                            }
                                            helperText={
                                              touched.occupationIfOthers &&
                                              errors.occupationIfOthers?.toString()
                                            }
                                            className={ProfileStyles.textfield}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            inputProps={{
                                              sx: {
                                                "&::label": {
                                                  fill: "var(--ds-text-primary)",
                                                  fontWeight: 400,
                                                  fontSize: "14px",
                                                },
                                                color: "var(--ds-text-primary)",
                                                fontSize: "14px",
                                                "&::placeholder": {
                                                  color:
                                                    "var(--ds-text-secondary)",
                                                  fontWeight: 400,
                                                  fontSize: "14px",
                                                  opacity: 0.6,
                                                },
                                              },
                                              maxLength: 50,
                                              inputMode: "text",
                                            }}
                                            sx={{
                                              fieldset: {
                                                borderColor: "#E5E7EB",
                                              },
                                            }}
                                            InputLabelProps={{
                                              sx: {
                                                color:
                                                  "var(--ds-text-secondary)",
                                                fontWeight: 400,
                                                fontSize: "14px",
                                                "&.MuiFormLabel-filled": {
                                                  color:
                                                    "var(--ds-text-primary)",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  fontFamily: "inherit",
                                                },
                                              },
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <div
                                          className={
                                            ProfileStyles.textFeildWrapper
                                          }
                                        ></div>
                                      )}
                                    </>
                                  )}
                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                  ></div>
                                </div>

                                <div className={ProfileStyles.sectionText}>
                                  Financial & Compliance Details
                                </div>

                                <div className={ProfileStyles.topContainer}>
                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Marital Status
                                    </div>
                                    {/* {isMobile ? (
                                      <CommonDropdownLatest
                                        LabelName="Marital Status"
                                        menuItems={maritalStatus}
                                        name="maritalStatus"
                                        value={values.maritalStatus}
                                        handleChange={handleChange}
                                        error={
                                          touched.maritalStatus &&
                                          Boolean(errors.maritalStatus)
                                        }
                                        helperText={
                                          touched.maritalStatus &&
                                          errors.maritalStatus
                                        }
                                        setOthers={""}
                                      />
                                    ) : ( */}
                                    <CommonRadioGroup
                                      LabelName="Marital Status"
                                      menuItems={maritalStatus}
                                      name="maritalStatus"
                                      value={values.maritalStatus}
                                      handleChange={handleChange}
                                      error={
                                        touched.maritalStatus &&
                                        Boolean(errors.maritalStatus)
                                      }
                                      helperText={
                                        touched.maritalStatus &&
                                        errors.maritalStatus
                                      }
                                      setOthers={""}
                                    />
                                    {/* )} */}
                                  </div>
                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Are You Politically Exposed
                                    </div>
                                    {/* {isMobile ? (
                                      <CommonDropdownLatest
                                        LabelName="Are You Politically Exposed"
                                        menuItems={politicallyExposed}
                                        name="areYouPoliticallyExposed"
                                        value={values.areYouPoliticallyExposed}
                                        handleChange={handleChange}
                                        error={
                                          touched.areYouPoliticallyExposed &&
                                          Boolean(
                                            errors.areYouPoliticallyExposed,
                                          )
                                        }
                                        helperText={
                                          touched.areYouPoliticallyExposed &&
                                          errors.areYouPoliticallyExposed
                                        }
                                        setOthers={""}
                                      />
                                    ) : ( */}
                                    <CommonRadioGroup
                                      LabelName="Are You Politically Exposed"
                                      menuItems={politicallyExposed}
                                      name="areYouPoliticallyExposed"
                                      value={values.areYouPoliticallyExposed}
                                      handleChange={handleChange}
                                      error={
                                        touched.areYouPoliticallyExposed &&
                                        Boolean(errors.areYouPoliticallyExposed)
                                      }
                                      helperText={
                                        touched.areYouPoliticallyExposed &&
                                        errors.areYouPoliticallyExposed
                                      }
                                      setOthers={""}
                                    />
                                    {/* )} */}
                                  </div>
                                </div>
                                <div className={ProfileStyles.topContainer}>
                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                    style={{ width: "100%" }}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Annual Income
                                    </div>
                                    {/* {isMobile ? (
                                      <CommonDropdownLatest
                                        LabelName="Annual Income"
                                        menuItems={annualIncomeOptions}
                                        name="annualIncome"
                                        value={values.annualIncome}
                                        handleChange={handleChange}
                                        error={
                                          touched.annualIncome &&
                                          Boolean(errors.annualIncome)
                                        }
                                        helperText={
                                          touched.annualIncome &&
                                          errors.annualIncome
                                        }
                                        setOthers={""}
                                      />
                                    ) : ( */}
                                    <CommonRadioGroup
                                      LabelName="Annual Income"
                                      menuItems={annualIncomeOptions}
                                      name="annualIncome"
                                      value={values.annualIncome}
                                      handleChange={handleChange}
                                      error={
                                        touched.annualIncome &&
                                        Boolean(errors.annualIncome)
                                      }
                                      helperText={
                                        touched.annualIncome &&
                                        errors.annualIncome
                                      }
                                      setOthers={""}
                                    />
                                    {/* )} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={ProfileStyles.buttonStack}>
                              <div className={ProfileStyles.buttonSectionLeft}>
                                <div className={ProfileStyles.otherBrokersText}>
                                  Previous Dealings with Other Brokers{" "}
                                  <span
                                    style={{
                                      color: "var(--ds-text-secondary)",
                                    }}
                                  >
                                    (Optional)
                                  </span>
                                  <Button
                                    variant="outlined"
                                    startIcon={<ControlPointOutlinedIcon />}
                                    onClick={() => {
                                      setExpandOthers(!expandOthers);
                                    }}
                                    className={ProfileStyles.addbutton}
                                    style={{ color: "var(--ds-text-primary)" }}
                                  >
                                    Add{" "}
                                    <span className={ProfileStyles.details}>
                                      Details
                                    </span>
                                  </Button>
                                </div>
                              </div>
                              <div className={ProfileStyles.buttonSectionRight}>
                                {values.areYouPoliticallyExposed &&
                                values.fatherFullName &&
                                values.motherFullName &&
                                values.annualIncome &&
                                values.occupation &&
                                values.maritalStatus &&
                                values.tradingExperience &&
                                // values.settlements &&
                                (values.occupation.value === "Others"
                                  ? Boolean(values.occupationIfOthers)
                                  : true) &&
                                !errors.fatherFullName &&
                                !errors.motherFullName ? (
                                  <LoadingButton
                                    loading={loading}
                                    variant="contained"
                                    type="submit"
                                    id="yourProfileContinueButton"
                                    onClick={() => {
                                      handleSubmit();
                                    }}
                                    className={ProfileStyles.approveButton}
                                  >
                                    Continue
                                  </LoadingButton>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled
                                    onClick={() => {
                                      handleSubmit();
                                    }}
                                    className={ProfileStyles.approveButton}
                                  >
                                    Continue
                                  </Button>
                                )}
                              </div>
                            </div>
                          </form>
                        );
                      }}
                    </Formik>
                  ) : (
                    <div style={{ height: "80vh" }}>
                      <BackDrop />
                    </div>
                  )}
                </div>
              </div>
            </>

            <PloiticalModal openModal={openModal} handleDone={handleDone} />
          </div>
        </div>
      </div>

      <Modal
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        open={expandOthers}
        slotProps={{
          backdrop: {
            timeout: 100,
          },
        }}
        BackdropProps={{
          style: {
            background: "rgba(31, 41, 55, 0.30)",
            backdropFilter: "blur(3px)",
            WebkitBackdropFilter: "blur(3px)",
          },
          timeout: 100,
        }}
      >
        <Box sx={successModalStyles}>
          <div className={ProfileStyles.modalWrapper}>
            <p className={ProfileStyles.title}>
              Previous Dealings with Other Brokers{" "}
            </p>
            <div className={ProfileStyles.bottomFeilds}>
              <div className={ProfileStyles.textFeildWrapper}>
                <div className={ProfileStyles.labeltext}>
                  Past Actions (Optional)
                </div>

                <TextField
                  autoComplete="off"
                  className={ProfileStyles.textfield}
                  id="outlined-basic"
                  // label="Father's Name"
                  placeholder="Provide details of SEBI, Stock Exchange, or other authority proceedings (in last 3 years)"
                  variant="outlined"
                  name="fatherFullName"
                  value={pastActions}
                  onChange={(event: any) => {
                    setPastActions(event.target.value);
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "var(--ds-text-primary)",
                        fontWeight: 400,
                        fontSize: "14px",
                      },
                      color: "var(--ds-text-primary)",
                      fontSize: "14px",
                      "&::placeholder": {
                        color: "var(--ds-text-secondary)",
                        fontWeight: 400,
                        fontSize: "14px",
                        opacity: 0.6,
                      },
                    },
                    maxLength: 50,
                    inputMode: "text",
                  }}
                  sx={{
                    width: "100%",
                    fieldset: {
                      borderColor: "#E5E7EB",
                      // borderRadius: "100px",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "var(--ds-text-secondary)",
                      fontWeight: 400,
                      fontSize: "14px",
                      // marginTop:"2px",
                      "&.MuiFormLabel-filled": {
                        color: "var(--ds-text-primary)",
                        fontWeight: 400,
                        fontSize: "15px",
                        fontFamily: "inherit",
                      },
                    },
                  }}
                />
              </div>

              <div className={ProfileStyles.textFeildWrapper}>
                <div className={ProfileStyles.labeltext}>
                  Dealings with other broker (Optional)
                </div>
                <TextField
                  autoComplete="off"
                  className={ProfileStyles.textfield}
                  id="outlined-basic"
                  // label="Mother's Name"
                  placeholder="Enter other broker details, client code, exchanges, and disputes"
                  variant="outlined"
                  name="motherFullName"
                  value={otherBrokers}
                  onChange={(event: any) => {
                    setOtherBrokers(event.target.value);
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "var(--ds-text-primary)",
                        fontWeight: 400,
                        fontSize: "14px",
                      },
                      color: "var(--ds-text-primary)",
                      fontSize: "14px",
                      "&::placeholder": {
                        color: "var(--ds-text-secondary)",
                        fontWeight: 400,
                        fontSize: "14px",
                        opacity: 0.6,
                      },
                    },
                    maxLength: 50,
                    inputMode: "text",
                  }}
                  sx={{
                    width: "100%",
                    fieldset: {
                      borderColor: "#E5E7EB",
                      // borderRadius: "100px",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "var(--ds-text-secondary)",
                      fontWeight: 400,
                      fontSize: "14px",
                      "&.MuiFormLabel-filled": {
                        color: "var(--ds-text-primary)",
                        fontWeight: 400,
                        fontSize: "15px",
                        fontFamily: "inherit",
                      },
                    },
                  }}
                />
              </div>
            </div>
            <div className={ProfileStyles.cancelButtonsSection}>
              <Button
                variant="outlined"
                className={ProfileStyles.approveButton}
                onClick={() => {
                  setExpandOthers(!expandOthers);
                }}
                style={{ color: "var(--ds-text-primary)" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className={ProfileStyles.approveButton}
                onClick={() => {
                  setExpandOthers(!expandOthers);
                }}
              >
                Submit & Continue
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
